import * as React from 'react';
import {clsx} from 'clsx';

type Props = {
	children?: React.ReactNode
	className?: string,
}

function BackgroundCheckered({ children, className, ...otherProps}: Props) {
	return (<>
		<div className={clsx("flex justify-center items-center", className)} {...otherProps}>
			<div className="bg-checkered">{children}</div>
		</div>
	</>);
}

export default BackgroundCheckered;
